import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type TaxIDGeneralFormType = PersonalIdentifierGeneralFormType;

export const TaxIDGeneralSection: TaxIDGeneralFormType = {
  ...commonGeneralFields,
};

export type TaxIDDetailsDto = Omit<
  PersonalIdentifierDetails,
  | 'createdAt'
  | 'updatedAt'
  | 'endDate'
  | 'gender'
  | 'birthDate'
  | 'placeOfBirth'
  | 'issuerCode'
  | 'basisForIssuingId'
  | 'other'
> & {
  idOfficialName?: string;
  taxAuthorityCode?: string;
  taxObligations?: string;
};

type TaxIDDetailsHelp = {
  idOfficialName: QuestionType.TEXT;
  taxAuthorityCode: QuestionType.TEXT;
  taxObligations: QuestionType.TEXT;
};

export type TaxIDDetailsFormType = TDtoWrapper<TaxIDDetailsDto, TaxIDDetailsHelp>;

export const TaxIDDetailsSection: TaxIDDetailsFormType = {
  taxAuthorityCode: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:taxID.inputs.taxAuthorityCode.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  taxObligations: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:taxID.inputs.taxObligations.label',
    value: '',
    capitalized: true,
    order: 9,
  },
  ...omit(
    commonDetailsFields,
    'endDate',
    'gender',
    'birthDate',
    'placeOfBirth',
    'issuerCode',
    'basisForIssuingId',
    'other',
  ),
};

export const TaxIDLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const TaxIDFormSections = [
  TaxIDGeneralSection,
  TaxIDDetailsSection,
  TaxIDLegalizedCopiesSection,
];
